import React, { Fragment } from 'react'
import { MultiSelect } from 'carbon-components-react'

import { CloseOutline16 } from '@carbon/icons-react'
import './index.scss'

const MultiSelectWithPreview = (props) => {
  const { value, label, onChange } = props

  const removeItem = (element) => {
    value.splice(value.indexOf(element), 1)
    onChange(value)
  }

  const renderValue = () => {
    return value.map(element => (
      <div className='element-preview'>
        <div className='container-icon-preview'>
          <span className='icon-preview' onClick={() => removeItem(element)}><CloseOutline16/></span>
          {element.value}
        </div>
      </div>
    ))
  }

  return (
    <Fragment>
      {(
        <div>
          <label className='bx--label fs-14'>{label}</label>
          <div className='value-preview'>
            {renderValue()}
          </div>
        </div>
      )}
      <MultiSelect
        {...props}
        label=''
        titleText=''
      />
    </Fragment>
  )
}

export default MultiSelectWithPreview
